export const HOME_PAGE = '/';
export const SIGNUP_PAGE = '/signup';
export const REGISTER_PAGE = '/register';
export const REFERRAL_CODE_PAGE = '/code';
export const VESSEL_PAGE = '/vessel';
export const WAITING_PAGE = '/waiting';
export const CONGRATS_PAGE = '/congrats';